import { getWeeksOfMonth } from './utils';
import { YearMonthDay } from './types';
import { DayGridHeader, DayGridRow } from './components';
import { Locale, locales } from '@ardoq/locale';
import { Stack } from '@ardoq/layout';
import { type I18nLocale } from '@ardoq/i18n';

type MonthProps = {
  readonly year: number;
  readonly month: number;
  readonly selected: YearMonthDay | null;
  readonly selectDay: (day: number) => void;
  readonly isDayDisabled?: (date: Date) => boolean;
  readonly locale: Locale;
  readonly disabledDayPopoverText?: string;
  readonly i18nLocale: I18nLocale;
};

const Month = ({
  year,
  month,
  selected,
  selectDay,
  isDayDisabled = () => false,
  locale,
  disabledDayPopoverText,
  i18nLocale,
}: MonthProps) => {
  // This condition will check the locale and based on that the days and date will render
  // So if the locale is not en-US the day should start from Monday
  const startWeekWithMonday = locale.code !== locales.enUS.code;
  const weeksOfMonth = getWeeksOfMonth(year, month, startWeekWithMonday);
  const isCurrentMonthSelected =
    year === selected?.year && month === selected?.month;
  return (
    <Stack gap="medium" justify="center" align="center">
      <DayGridHeader locale={locale} i18nLocale={i18nLocale} />
      <Stack justify="center" align="center" gap="xsmall">
        {weeksOfMonth.map((week, index) => (
          <DayGridRow
            key={index}
            data={week}
            activeDay={isCurrentMonthSelected ? selected?.day : undefined}
            onSelectDay={selectDay}
            isDayDisabled={isDayDisabled}
            disabledDayPopoverText={disabledDayPopoverText}
            {...{ year, month }}
          />
        ))}
      </Stack>
    </Stack>
  );
};

export { Month };
